import React from "react";
import {
  TabStrip,  
  TabStripProps,  
  TabStripSelectEventArguments
} from "@progress/kendo-react-layout";
import "@progress/kendo-react-intl";

export interface TabStripSelectEventArgumentsCustom extends TabStripSelectEventArguments{
    groupId: string;
}

interface TabStripCustomProps extends TabStripProps {   
    onSelectCustom: (e: TabStripSelectEventArgumentsCustom) => void;
    
}

export const TabStripCustom: React.FC<TabStripCustomProps> = (props) => {
    const { onSelect, ...rest } = props;
    return (
        <TabStrip
            {...rest}
            onSelect={(e) => {
                if (Array.isArray(props.children)) {
                    const selectedChild = props.children[e.selected] as React.ReactElement;
                    props.onSelectCustom({ ...e, groupId: selectedChild.props.dataGroupId });
                }
            }}
        >
            {props.children}
        </TabStrip>
    );
};